import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import moment from "moment/moment";
import { applyMask } from "../../../utils";
import { DataTableColumn, StatusBadge, UserAvatar } from "../../../components/ui";
import { UserModel } from "./table/user.model";

type Options = {
    onCancelPlan: (id: number) => void;
};

/** Colunas da tabela de usuários (Usuário / Plano / Telefone / Fim do plano / Ações). */
export function buildUserColumns({ onCancelPlan }: Options): DataTableColumn<UserModel>[] {
    return [
        {
            key: "usuario",
            header: "Usuário",
            width: "2fr",
            render: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                    <UserAvatar label={row.name || row.email} size={34} />
                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            sx={{
                                fontSize: "13.5px",
                                fontWeight: 600,
                                color: "text.primary",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {row.name}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: "12px",
                                color: "text.secondary",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {row.email}
                        </Typography>
                    </Box>
                </Box>
            ),
        },
        {
            key: "plano",
            header: "Plano",
            render: (row) => (row.planName ? <StatusBadge status={row.planName} tone="success" /> : <StatusBadge status="Sem plano" />),
        },
        {
            key: "telefone",
            header: "Telefone",
            render: (row) => (
                <Typography sx={{ fontSize: "13.5px", color: "text.primary" }}>
                    {row.phone ? applyMask("phone").onValue(row.phone) : "—"}
                </Typography>
            ),
        },
        {
            key: "fim_plano",
            header: "Fim do plano",
            render: (row) => (
                <Typography sx={{ fontSize: "13.5px", color: "text.secondary" }}>
                    {row.datEndPlan ? moment(row.datEndPlan).utcOffset(-180).format("DD/MM/YYYY") : "—"}
                </Typography>
            ),
        },
        {
            key: "acoes",
            header: "Ações",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Tooltip title={row.planName ? "Cancelar plano" : "Sem plano ativo"}>
                        <span>
                            <IconButton
                                size="small"
                                color="error"
                                disabled={!row.planName}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onCancelPlan(row.id);
                                }}
                            >
                                <DoNotDisturbAltIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
